import PropTypes from "prop-types";
import React from "react";
import styled from "styled-components";

import { Box, Surface, Row, Col } from "@mm/ui";

import { Loading } from "components/molecules";
import { useOfferConfigurator } from "features/Offer";

import FilteredItems from "./FilteredItems";
import Toolbar from "./Toolbar";
import TariffFacets from "./facets/Tariff";
import HardwareFacets from "./facets/Hardware";
import SelectedFilters from "./SelectedFilters";
import { useFilterProvider } from "./FilterProvider";

const StyledRow = styled(Row)({
  "> div > div": {
    borderTop: ({ theme: { colors } }) => `1px solid ${colors.shade[2]}`,
    paddingTop: ({ theme: { space } }) => `${space.s}px`,
  },
});

/**
 * A facetted search component to narrow down tariff and hardware options
 */
const FilterSection = ({ variant }) => {
  const Facet = variant === "tariff" ? TariffFacets : HardwareFacets;
  const {
    state: { isListingPage },
  } = useOfferConfigurator();

  const {
    state: { data, showAllFacets, collapseFilter, activeKeys },
  } = useFilterProvider();

  const loaderVariant = isListingPage ? "listing" : "filter";

  let activeKey = activeKeys;
  if (showAllFacets === true) {
    activeKey = [...Array(20).keys()].slice(1);
  } else if (showAllFacets === false) {
    activeKey = [];
  }

  if (!data)
    return <Loading variant={loaderVariant} gridWrapper marginTop={4} />;

  return (
    <Surface variant="narrow" id="filter" mt={[4, 4, 4, 6, 6]}>
      <Toolbar />
      <StyledRow mt={[4, 4, 4, 6, 6]}>
        <Col xs={24} md={8} lg={6}>
          <Facet activeKey={activeKey} collapseFilter={collapseFilter} />
        </Col>
        <Col xs={24} md={16} lg={18}>
          <Box mt={["m", null, null, 0]}>
            <SelectedFilters />
            <FilteredItems />
          </Box>
        </Col>
      </StyledRow>
    </Surface>
  );
};

FilterSection.propTypes = {
  variant: PropTypes.oneOf(["smartphone", "tariff"]).isRequired,
  queryParams: PropTypes.shape({}),
};

FilterSection.defaultProps = {
  queryParams: null,
};

export default FilterSection;
